import { render, staticRenderFns } from "./DesignStudioV2Toggle.vue?vue&type=template&id=cc85b40a&"
import script from "./DesignStudioV2Toggle.vue?vue&type=script&lang=js&"
export * from "./DesignStudioV2Toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports